<!-- 付款信息确认 -->
<style lang="scss" scoped>
.payment-info-wrapper {
  background: #ffffff;
  padding: 20px;

  .account-info {
    .upload-label {
      margin-bottom: 8px !important;
    }
    .label {
      font-size: 14px;
      color: #999999;
      margin-bottom: 2px;
      &::before {
        content: '*';
        display: inline-block;
        color: #ff0000;
        margin-right: 2px;
      }
    }
    .value {
      font-size: 16px;
      margin-bottom: 10px;
    }
  }

  .copy-all-btn {
    color: $color-primary;
    font-size: 16px;
    border-bottom: 1px solid $color-primary;
    cursor: pointer;
    margin-bottom: 12px;
  }
}
.footer {
  text-align: end;
  margin-top: 20px;
}
</style>

<template>
  <div class="payment-info-wrapper mt-24px">
    <div class="flex items-center justify-between">
      <div class="g-title">
        打款账户
        <span class="text-red"
          >请使用申请名称账户将{{ yuan2wan(paymentInfoData.totalAmount) }}万元 （入驻费{{ yuan2wan(paymentInfoData.entryFee) }}万元及保证金{{
            yuan2wan(paymentInfoData.deposit)
          }}万元）打款到以下账户，打款后上传付款截图。</span
        >
      </div>
      <div v-copy="{ value: getCopyContent(), onSuccess: successFn, onError: errorFn }" class="copy-all-btn">一键复制</div>
    </div>

    <el-row :gutter="20">
      <template v-for="item in paymentInfo" :key="item.label">
        <el-col v-if="item.type === 'upload'" :span="12">
          <div class="account-info">
            <div class="label upload-label">上传付款截图</div>
            <img-upload
              v-model="form.paymentProofUrl"
              :dir="OSS_DIR.OPERATION_UPLOAD_FILE"
              height="160"
              width="100%"
              :size-limit="2"
              accept="image/jpg,image/jpeg,image/png"
            >
              <template #empty>
                <div class="text-14px color-#666666"><span class="upload-txt">点击</span><span class="drag-txt">/拖拽至此处上传文件</span></div>
                <div class="color-#999999">（支持jpg/jpeg/png格式，不超过 2 M）</div>
              </template>
            </img-upload>
          </div>
        </el-col>
        <el-col v-else-if="item.type === 'attachment'" :span="item.span">
          <div class="mt-4">
            <div class="label upload-label mb-2">{{ item.label }}</div>
            <FilesUpload
              v-model="form.attachmentFiles"
              :disabled="false"
              :dir="OSS_DIR.OPERATION_UPLOAD_FILE"
              :size-limit="100"
              :limit="5"
              width="200"
              accept=".pdf,.txt,application/x-rar-compressed,application/x-rar,.rar,application/zip,application/x-zip-compressed,application/x-zip"
              :is-zip="true"
              :show-preview-mask="false"
            >
              <template #empty>
                <div class="upload-text">
                  <div class="text-#666666">点击/拖拽至此处上传其他附件</div>
                  <div class="text-12px text-#999999">(最多上传5个附件，单个附件不超过100M)</div>
                </div>
              </template>
            </FilesUpload>
          </div>
        </el-col>
        <el-col v-else :span="item.span">
          <div class="account-info">
            <div class="label">{{ item.label }}</div>
            <div v-copy="{ value: item.value, onSuccess: successFn, onError: errorFn }" class="value">
              {{ item.value }}
              <icon class="ml-16px mr-16px cursor-pointer text-#999999" size="20" type="yiyuan-copy1"></icon>
              <span class="text-16px text-#999999">{{ item.desc }}</span>
            </div>
          </div>
        </el-col>
      </template>
    </el-row>
  </div>
  <div class="footer">
    <el-button size="large" @click="cancel">取消</el-button>
    <el-button size="large" @click="prevStep">上一步</el-button>
    <el-button type="primary" size="large" @click="paySubmit">下一步</el-button>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { OSS_DIR } from '@/constants/common'
import userApi from '@/apis/user'
import event from '@/event/index'
import { CLOSE_JOIN_CORP_DIALOG } from '@/event/modules/site'
import { extractFileNameFromUrl, parseNum, yuan2wan } from '@/utils/utils'

const paymentInfo = ref([
  { label: '账户名称', key: 'accountName', value: '', span: 12 },
  { label: '银行账户', key: 'bankAccount', value: '', span: 12 },
  { label: '开户行名称', key: 'bankName', value: '', span: 12 },
  { label: '开户行号', key: 'bankCode', value: '', span: 12 },
  {
    label: '总打款金额',
    key: 'totalAmount',
    value: '',
    span: 24,
    desc: '（含入驻费3万元及保证金1万元）',
  },
  { label: '上传付款截图', value: '', span: 12, type: 'upload' },
  { label: '上传其他附件', value: '', span: 24, type: 'attachment' },
])

const form = ref({
  paymentProofUrl: null,
  attachmentFiles: [],
})
const paymentInfoData = ref({})

onMounted(async () => {
  const res = await userApi.getPartnerJoinPaymentInfo()
  paymentInfoData.value = res
  paymentInfo.value = paymentInfo.value.map((item) => {
    return {
      ...item,
      value: res[item.key],
      desc: item.key === 'totalAmount' ? `（含入驻费${parseNum(res.entryFee)}及保证金${parseNum(res.deposit)}元）` : '',
    }
  })
})

const props = defineProps({
  close: {
    type: Function,
    default: () => {},
  },
  prevStep: {
    type: Function,
    default: () => {},
  },
  nextStep: {
    type: Function,
    default: () => {},
  },
  joinData: {
    type: Object,
    default: () => {},
  },
})

// 复制成功提示
const successFn = () => {
  ElMessage.success('复制成功')
}

// 复制失败提示
const errorFn = () => {
  ElMessage.error('复制失败')
}

const cancel = async () => {
  try {
    await userApi.postCancelJoinProcess({ corpId: props.joinData.corpId })
    event.emit(CLOSE_JOIN_CORP_DIALOG) //关闭合伙人入驻流程窗口
    // event.emit(OPEN_PARTNER_MODE_DIALOG) //打开合伙人模式选择窗口
  } catch (error) {
    console.log(error)
  }
}
const prevStep = () => {
  props.prevStep()
}

const handleAttachment = (list) => {
  return list.map((url) => {
    const fileName = extractFileNameFromUrl(url)
    return {
      fileUrl: url,
      fileName: fileName,
    }
  })
}

const paySubmit = async () => {
  try {
    const attachmentFiles = handleAttachment(form.value.attachmentFiles)
    if (!form.value.paymentProofUrl) {
      ElMessage.error('请上传付款截图')
      return
    }
    await userApi.submitPaymentProof({ corpId: props.joinData.corpId, paymentProofUrl: form.value.paymentProofUrl, attachmentFiles })
    ElMessage.success('提交成功')
    props.nextStep()
  } catch (error) {
    console.log(error)
  }
}
//一件复制
const getCopyContent = () => {
  //账户名称\n银行账户\n开户行名称\n开户行号\总打款金额
  return `账户名称：${paymentInfoData.value.accountName}\n银行账户：${paymentInfoData.value.bankAccount}\n开户行名称：${paymentInfoData.value.bankName}\n开户行号：${paymentInfoData.value.bankCode}\n总打款金额：${paymentInfoData.value.totalAmount}`
}
</script>
